import {
  SET_CURRENT_ROUTE,
  A_ROUTER_MODULE_PER_ROUTE_ACTIONS,
  R_NAME_CREATE_A_STUDY,
  R_NAME_CREATE_STUDY_CHOOSE_NUMBER_OF_QUESTIONS,
  R_NAME_CREATE_STUDY_QUESTIONS,
  R_NAME_CREATE_STUDY_ANSWERS_OF_QUESTION_N,
  R_NAME_CREATE_STUDY_SEGMENT_QUESTION_N,
  R_NAME_CREATE_STUDY_OPEN_ENDED_QUESTION,
  R_NAME_CREATE_STUDY_RESPONDENT_ORIENTATION,
  R_NAME_CREATE_STUDY_RATING_SCALE,
  R_NAME_CREATE_STUDY_FINAL_THOUGHTS,
  R_NAME_CREATE_STUDY_DONE,
  R_NAME_MANAGE_STUDY_CHOOSE_SOURCING_METHOD,
  GET_CURRENT_ROUTE,
  GET_NEXT_STUDY_STEP_ROUTE,
  GET_PREVIOUS_STUDY_STEP_ROUTE,
  GET_NAV_ROUTES,
  GET_IN_PROGRESS_STUDY_NUMBER_OF_QUESTIONS,
  GET_IN_PROGRESS_STUDY_NUMBER_OF_SEGMENT_QUESTIONS,
  R_NAME_HOME,
  R_NAME_ABOUT,
  R_NAME_BROWSE,
  R_NAME_CONTACT,
  GET_IS_CURRENT_ROUTE_PART_OF_EDIT_GROUP,
  GET_BACKEND_URL,
  GET_CURRENT_STUDY_EXCEL_URL,
  GET_CURRENT_STUDY_POWERPOINT_URL,
  R_NAME_RESULTS,
  R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_LANGUAGE,
  R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_PAYMENT,
  R_NAME_DASHBOARD,
  R_NAME_CREATE_STUDY_LOADING,
  GET_CURRENT_STUDY_EXCEL_URL_FLASH,
  R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_QUESTION,
  LOADING_COMPLETED_SUCCESS,
  GET_CURRENT_QUESTION_NAME,
  STUDY_SOURCE_SELECTION_SELF,
  STUDY_SOURCE_SELECTION_CUSTOM,
  STUDY_SOURCE_SELECTION_EXTERNAL,
  STUDY_SOURCE_SELECTION_DEMO,
  R_NAME_CREATE_STUDY_POST_PRESENTATION_MEDIA,
  R_NAME_CREATE_STUDY_PRE_OPTIONAL_QUESTION,
  GET_CURRENT_STUDY_IDEABOOK_URL,
} from "@/services/constants";
import { R_NAME_CREATE_STUDY_PRESENTATION_MEDIA } from "../services/constants";

const module = {
  state: {
    currentRoute: null,
  },
  getters: {
    [GET_CURRENT_ROUTE](state) {
      return state.currentRoute;
    },
    [GET_CURRENT_QUESTION_NAME](state, getters) {
      return getters[GET_CURRENT_ROUTE].params.questionName;
    },
    [GET_IS_CURRENT_ROUTE_PART_OF_EDIT_GROUP](state, getters, rootState) {
      const currentRoute = getters[GET_CURRENT_ROUTE];
      if (currentRoute) {
        return currentRoute.matched.some((record) => {
          return record.meta.editGroup;
        });
      }
      return false;
    },
    [GET_NEXT_STUDY_STEP_ROUTE](state, getters, rootState) {
      const route = {
        name: "",
        query: state.currentRoute.query,
      };
      switch (state.currentRoute.name) {
        case R_NAME_CREATE_A_STUDY:
          route.name = R_NAME_CREATE_STUDY_QUESTIONS;
          break;
        case R_NAME_CREATE_STUDY_CHOOSE_NUMBER_OF_QUESTIONS:
          route.name = R_NAME_CREATE_STUDY_QUESTIONS;
          break;
        case R_NAME_CREATE_STUDY_QUESTIONS:
          route.params = {
            n: 1,
          };
          route.name = R_NAME_CREATE_STUDY_ANSWERS_OF_QUESTION_N;
          break;
        case R_NAME_CREATE_STUDY_ANSWERS_OF_QUESTION_N:
          const count = getters[GET_IN_PROGRESS_STUDY_NUMBER_OF_QUESTIONS];
          const current = Number(state.currentRoute.params.n);
          if (count === current) {
            route.name = R_NAME_CREATE_STUDY_SEGMENT_QUESTION_N;
            route.params = {
              n: 1,
            };
          } else {
            route.name = R_NAME_CREATE_STUDY_ANSWERS_OF_QUESTION_N;
            route.params = {
              n: current + 1,
            };
          }
          break;
        case R_NAME_CREATE_STUDY_SEGMENT_QUESTION_N:
          const currentSegment = Number(state.currentRoute.params.n);
          if (getters[GET_IN_PROGRESS_STUDY_NUMBER_OF_SEGMENT_QUESTIONS] === currentSegment) {
            route.name = R_NAME_CREATE_STUDY_PRESENTATION_MEDIA;
          } else {
            route.name = R_NAME_CREATE_STUDY_SEGMENT_QUESTION_N;
            route.params = {
              n: currentSegment + 1,
            };
          }
          break;
        case R_NAME_CREATE_STUDY_PRESENTATION_MEDIA:
          route.name = R_NAME_CREATE_STUDY_PRE_OPTIONAL_QUESTION;
          break;
        case R_NAME_CREATE_STUDY_PRE_OPTIONAL_QUESTION:
          route.name = R_NAME_CREATE_STUDY_RESPONDENT_ORIENTATION;
          break;
        case R_NAME_CREATE_STUDY_RESPONDENT_ORIENTATION:
          route.name = R_NAME_CREATE_STUDY_RATING_SCALE;
          break;
        case R_NAME_CREATE_STUDY_RATING_SCALE:
          route.name = R_NAME_CREATE_STUDY_POST_PRESENTATION_MEDIA;
          break;
        case R_NAME_CREATE_STUDY_POST_PRESENTATION_MEDIA:
          route.name = R_NAME_CREATE_STUDY_OPEN_ENDED_QUESTION;
          break;
        case R_NAME_CREATE_STUDY_OPEN_ENDED_QUESTION:
          route.name = R_NAME_CREATE_STUDY_FINAL_THOUGHTS;
          break;
        case R_NAME_CREATE_STUDY_FINAL_THOUGHTS:
          route.name = R_NAME_MANAGE_STUDY_CHOOSE_SOURCING_METHOD;
          break;
        case R_NAME_MANAGE_STUDY_CHOOSE_SOURCING_METHOD:
          let method = rootState.dataModule.inProgressStudy.sourcingMethod;
          if (
            method === STUDY_SOURCE_SELECTION_SELF ||
            method === STUDY_SOURCE_SELECTION_CUSTOM ||
            method === STUDY_SOURCE_SELECTION_EXTERNAL ||
            method === STUDY_SOURCE_SELECTION_DEMO
          ) {
            route.name = R_NAME_CREATE_STUDY_DONE;
          } else {
            route.name = R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_LANGUAGE;
          }
          break;
        case R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_LANGUAGE:
          let thereAreQualifications = rootState.dataModule.qualifications.data.length > 0;
          if (thereAreQualifications) {
            route.name = R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_QUESTION;
            route.params = {
              questionName: rootState.dataModule.qualifications.data[0].name,
            };
          } else {
            route.name = R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_PAYMENT;
          }
          break;
        case R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_QUESTION:
          let currentQuestion = getters[GET_CURRENT_QUESTION_NAME];
          let qualifications = rootState.dataModule.qualifications.data;
          let indexOfCurrentQuestion = 0;
          for (let i = 0; i < qualifications.length; i++) {
            if (currentQuestion === qualifications[i].name) {
              indexOfCurrentQuestion = i;
            }
          }
          let lastQuestion = indexOfCurrentQuestion >= qualifications.length - 1;
          if (lastQuestion) {
            route.name = R_NAME_CREATE_STUDY_DONE;
          } else {
            route.name = R_NAME_MANAGE_STUDY_SURVEY_QUALIFICATIONS_QUESTION;
            if (rootState.dataModule.qualifications.loadingState === LOADING_COMPLETED_SUCCESS) {
              route.params = {
                questionName:
                  rootState.dataModule.qualifications.data[indexOfCurrentQuestion + 1].name,
              };
            }
          }
          break;
        case R_NAME_CREATE_STUDY_DONE:
          route.name = R_NAME_RESULTS;
          route.params = { id: rootState.dataModule.inProgressStudy.meta.id };
          break;
        default:
          route.name = R_NAME_CREATE_A_STUDY;
          break;
      }
      return route;
    },
    [GET_PREVIOUS_STUDY_STEP_ROUTE](state, getters) {
      const route = {
        name: "",
      };
      switch (state.currentRoute.name) {
        case R_NAME_CREATE_STUDY_SEGMENT_QUESTION_N:
          const currentSegment = Number(state.currentRoute.params.n);
          if (getters[GET_IN_PROGRESS_STUDY_NUMBER_OF_SEGMENT_QUESTIONS] === 1) {
            route.name = R_NAME_CREATE_STUDY_SEGMENT_QUESTION_N;
            route.params = {
              n: 1,
            };
          } else {
            route.name = R_NAME_CREATE_STUDY_SEGMENT_QUESTION_N;
            route.params = {
              n: currentSegment - 1,
            };
          }
          break;
        default:
          route.name = R_NAME_CREATE_A_STUDY;
          break;
      }
      return route;
    },
    [GET_NAV_ROUTES]() {
      return [
        {
          ui: {
            name: "HOME",
          },
          route: {
            name: R_NAME_HOME,
          },
        },
        {
          ui: {
            name: "ABOUT",
          },
          route: {
            name: R_NAME_ABOUT,
          },
        },
        {
          ui: {
            name: "BROWSE",
          },
          route: {
            name: R_NAME_BROWSE,
          },
        },
        {
          ui: {
            name: "DASHBOARD",
          },
          route: {
            name: R_NAME_DASHBOARD,
          },
        },
        {
          ui: {
            name: "CREATE",
          },
          route: {
            name: R_NAME_CREATE_STUDY_LOADING,
          },
        },
        {
          ui: {
            name: "CONTACT",
          },
          route: {
            name: R_NAME_CONTACT,
          },
        },
      ];
    },
    [GET_CURRENT_STUDY_EXCEL_URL](state, getters) {
      return `${getters[GET_BACKEND_URL]("results/exported")}/${state.currentRoute.params.id}`;
    },
    [GET_CURRENT_STUDY_EXCEL_URL_FLASH](state, getters) {
      return `${getters[GET_BACKEND_URL]("results/exported")}/${
        state.currentRoute.params.id
      }/flash`;
    },
    [GET_CURRENT_STUDY_POWERPOINT_URL](state, getters) {
      return `${getters[GET_BACKEND_URL]("results/exported/ppt")}/${state.currentRoute.params.id}`;
    },
    [GET_CURRENT_STUDY_IDEABOOK_URL](state, getters) {
      return `${getters[GET_BACKEND_URL]("results/ideabook")}/${state.currentRoute.params.id}`;
    },
  },
  mutations: {
    [SET_CURRENT_ROUTE](state, payload) {
      state.currentRoute = payload;
    },
  },
  actions: {
    [A_ROUTER_MODULE_PER_ROUTE_ACTIONS]: (context, toRoute) => {
      context.commit(SET_CURRENT_ROUTE, toRoute);
    },
  },
};

export default module;
export const routerModule = module;
